module.exports = __webpack_public_path__ + "static/media/lowresportfolio-4.a1c18617.jpg";